import React from 'react';
import { Navigate } from 'react-router-dom';
import LoaderScreen from './loader/loaderScreen';
import { useSelector } from 'react-redux';

const User_ProtectedRoute = ({ isAuthenticated, children }) => {
  const { profileLoader } = useSelector((state) => state.user_profile);

  console.log(profileLoader, 'seasonf of work');

  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to="/auth/signin" replace />;
  }

  return (
    <>
      <div class="page-content lg:ml-[280px]">
        <div class="container-xxl container-fluid">
          {profileLoader ? <LoaderScreen /> : <>{children}</>}
        </div>
      </div>
    </>
  );
};

export default User_ProtectedRoute;
